import { Row, Col, Container, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import OpenGamesWidgets from "../components/widgets/OpenGamesWidgets";
import CustomTooltip from "../components/common/CustomTooltip";
import { getGameAssetsUrl } from "../utilities/Helpers";

import pvpIcon from '../styles/images/pvp.png';
import { Helmet } from "react-helmet";

const OpenGames = () => {
    const navigate = useNavigate();

    return (<>
        <Helmet>
            <title>Darknet Games | PVP Arena</title>
        </Helmet>
        <Container>
            <Row className='g-3 mb-3'>
                <Col>
                    <Card className='card-widget mb-3' id="library-widget">
                        <Card.Header>
                            <Card.Title className="text-light text-center fs-3">
                                PVP Arena
                            </Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <Row className="">
                                <Col>
                                    <h6>Game Legend</h6>
                                    <CustomTooltip title="Dark Pong" id="dark-pong-wagered" placement={"bottom"}>
                                        <button className="dg-btn dg-btn-mid-dark py-2" onClick={() => navigate(`/game/${1}`)}>
                                            <img src={`${getGameAssetsUrl(1)}/icon.png`} alt="Dark Pong" height={32} />
                                        </button>
                                    </CustomTooltip>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <Row className="mb-3">
                        <Col>
                            <OpenGamesWidgets />
                        </Col>
                    </Row>
                    <Card className="card-widget" id="disclaimer-widget">
                        <Card.Footer className="fs-8">
                            You must have an account and a Solana wallet to play games. Casual games do not require a deposit, but wagered games do.
                            Wagered games require a deposit of the SPL token you wish to wager plus a small SOL fee to cover transaction costs. When
                            you win a wagered game, you will receive your wager back plus your opponent's wager minus a small fee. If you lose, you
                            will lose your wager plus a small fee. The fee is used to fund the Darknet project.
                        </Card.Footer>
                    </Card>
                </Col>
            </Row>
        </Container>
    </>)
}

export default OpenGames;